import React, { useRef } from "react";
import CustomPosts from "../misc/custom-posts/CustomPosts";
import type { UseNicheReturn } from "../niche/useNiche";
import type { AddPostPreset } from "./preset";
import { useCloseAddPostCard } from "./useAddPostNavigation";

interface Props {
    preset: AddPostPreset;
    niche: UseNicheReturn;
}

/**
 * The five ad hoc cards: today's dialog, preset to the card. Closing it returns to the grid; once a
 * post has been created the close goes to the calendar instead.
 */
const AddPostDialog: React.FC<Props> = ({ preset, niche }) => {
    const closeCard = useCloseAddPostCard();
    // The wizard calls getAllPosts when posts were created: on success (then it closes itself) and on a
    // partial failure (then it stays open with its error, plan-limit dialog and Retry). So getAllPosts
    // only records the fact; the navigation happens on the close that follows, never mid-error.
    const scheduledRef = useRef(false);
    return (
        <CustomPosts
            open
            isAdHoc
            preset={preset}
            niche={niche}
            getAllPosts={() => {
                scheduledRef.current = true;
            }}
            setIsOpen={(open) => {
                if (!open) closeCard(scheduledRef.current);
            }}
        />
    );
};
export default AddPostDialog;
